// NOTE: The following type might need to be adjusted when the API data is ready
export interface SummaryItem {
  activity: string;
  driversAssigned: number;
  completed: number;
  notCompleted: number;
  completionPercentage: number;
}

export interface Score {
  verbalRating: string;
  percentageRating: number;
  ratingIcon: string;
  color: string;
}

export enum Dashboards {
  vrm = 'main',
  vrmUK = 'vrmUKDashboard',
  mvr = 'mainMVR',
  licenceCheck = 'licenceCheckDashboard',
  coaching = 'coachingDashboard',
  mentor = 'mentorDashboard',
}

/**
 * Maps a dashboard to the required menu items. If the value array has multiple
 * items then all menus must be visible for that dashboard to be accessible.
 *
 * You can negate a menu item by prefixing it with a `!` character. This will
 * make the dashboard accessible only if the menu item is not visible.
 *
 * You can also use a pipe `|` character to specify that at least one of the
 * menu items must be visible for the dashboard to be accessible.
 */
export const dashboardMenuAccessMap: { [key: string]: string[] } = {
  [Dashboards.vrm]: ['!licenceChecking'],
  [Dashboards.vrmUK]: ['licenceChecking'],
  [Dashboards.mvr]: ['mvrPlus'],
  [Dashboards.licenceCheck]: ['licenceChecking'],
  [Dashboards.coaching]: ['coaching'],
  [Dashboards.mentor]: ['mentorByEdriving|driverPerformanceReport'],
};
